import { buildCrudRoutes } from '@/app/arch/components/crud/CrudRouter';
import moduleBreadcrumbs from '../moduleBreadcrumbs';

const featureBreadCrumps = [
  ...moduleBreadcrumbs,
  {
    text: 'Listar feriados',
    disabled: false,
    to: 'holidays.list',
  },
];

export default [
  ...buildCrudRoutes({
    baseName: 'holidays',
    basePath: 'feriados',
    card: {
      title: 'Feriados',
      icon: 'home',
    },
    moduleActive: 'contacard',
    baseBreadcrumbs: featureBreadCrumps,
    listRoute: {
      pageContent: () => import('Modules/contacard/holidays/HolidaysCrudList.vue'),
      pageTitle: 'Listar feriados',
      navigateBackRoute: 'contacard.submodules.list',
      btnText: 'Adicionar feriado',
      newRouteName: 'holidays.new',
    },
    newRoute: {
      component: () => import('Modules/contacard/holidays/HolidaysForm.vue'),
      breadcrumbs: [
        {
          text: 'Gerenciar feriado',
          disabled: true,
        },
      ],
    },
    editRoute: {
      component: () => import('Modules/contacard/holidays/HolidaysForm.vue'),
      breadcrumbs: [
        {
          text: 'Gerenciar feriado',
          disabled: true,
        },
      ],
    },
  }),
];
